import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'
import { SAVE_SELECTED_THEME_SUCCESS } from '../actions/_actionTypes'

// Attention case should be respected
export default function themeReducer(state = initialState.selectedTheme, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_THEME_SUCCESS:
      return action.selectedTheme;
    default:
      return state;
  }
}
